import { RootState } from "../../../types/redux-types";

export const getWidgets = (state: RootState) => state.widgets.widgets;
export const isWidgetsLoading = (state: RootState) => state.widgets.isLoading;
export const getWidgetsCountry = (state: RootState) => state.widgets.country;
